let prefix = '/api/sap/usage-fiscal';
function getUsageFiscal() {
    return window.axios.get(prefix+'/index');
}
export default {
    getUsageFiscal,
}